import React, { useState, useEffect } from 'react';

const ProductionIdentifiers = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.TypeOfUDI_PI",
    fieldTitle = "Type of UDI-PI",
    forceIsEditing = null
}) => {
    // Option mapping from your Dictionary
    const identifierOptions = [
        { key: "BATCH_NUMBER", value: "BATCH NUMBER" },
        { key: "SERIALISATION_NUMBER", value: "SERIAL NUMBER" },
        { key: "MANUFACTURING_DATE", value: "MANUFACTURING DATE" },
        { key: "EXPIRATION_DATE", value: "EXPIRATION DATE" },
        { key: "SOFTWARE_IDENTIFICATION", value: "SOFTWARE IDENTIFICATION" },
    ];

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);

    // Parse initial data
    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch(e) {
            return [];
        }
    });

    // Local state for the dropdown selection
    const [selectedValue, setSelectedValue] = useState(identifierOptions[0].key);

    const handleAdd = () => {
        const selectedOption = identifierOptions.find(opt => opt.key === selectedValue);

        const newItem = {
            ProductionIdentifier: selectedOption.key,
            ProductionIdentifierText: selectedOption.value
        };

        const updatedItems = [...items, newItem];

        // 1. Update local UI state
        setItems(updatedItems);

        // 2. Update Global (Note: EUProductUDI and TypeOfUDI_PI)
        setUDI(prevItem => ({
            ...prevItem,
            TypeOfUDI_PI: updatedItems
        }));
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);

        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            TypeOfUDI_PI: updatedItems
        }));
    };



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    // --- Render Mode: Edit ---
    return (


        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?

                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className="table table-bordered" id="productEUUDIProductionIdentifiers_itemsTable">
                                    <thead>
                                        <tr>
                                            <th>Production Identifier</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.ProductionIdentifierText}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="udiRemoveButton"
                                                        onClick={() => handleRemove(index)}
                                                    >
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div style={{ marginTop: '15px' }}>
                                    Production Identifiers:
                                    <br />
                                    <select
                                        value={selectedValue}
                                        onChange={(e) => setSelectedValue(e.target.value)}
                                        style={{ width: '90%' }}
                                    >
                                        {identifierOptions.map((opt) => (
                                            <option key={opt.key} value={opt.key}>
                                                {opt.value}
                                            </option>
                                        ))}
                                    </select>
                                    <br /><br />

                                    <input
                                        type="button"
                                        className="udiActionButton"
                                        value="Add Production Identifier"
                                        onClick={handleAdd}
                                    />
                                </div>

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>


                            :


                            <>

                                <table className="dataTable" style={{ borderWidth: '1px', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Production Identifier</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.ProductionIdentifierText}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
                                <input
                                    type="button"
                                    className="udiActionButton"
                                    value="Edit"
                                    onClick={() => changeIsEditingField(true)}
                                />
                                */}

                            </>

                        }

                    </div>

                </div>
            </div>
        </div>






    );
};

export default ProductionIdentifiers;